export type MenuHapticPattern =
  | 'menuOpen'
  | 'rewardClaim'
  | 'levelComplete'
  | 'warning'
  | 'error';

const DISABLED_VALUES = new Set(['false', '0', 'off', 'disabled']);

function isExplicitlyDisabled(rawValue: string | null): boolean {
  if (!rawValue) return false;
  return DISABLED_VALUES.has(rawValue.trim().toLowerCase());
}

export function isHapticsEnabled(
  storage: Pick<Storage, 'getItem'> | null = typeof window !== 'undefined' ? window.localStorage : null
): boolean {
  if (!storage) return true;

  try {
    const vibrationSetting = storage.getItem('vibration');
    const legacyVibrationSetting = storage.getItem('vibrationEnabled');

    return !isExplicitlyDisabled(vibrationSetting) && !isExplicitlyDisabled(legacyVibrationSetting);
  } catch {
    // Fail open so inaccessible storage does not break interactions.
    return true;
  }
}

const MENU_PATTERNS: Record<MenuHapticPattern, number[]> = {
  menuOpen: [8],
  rewardClaim: [10, 20, 10, 30, 20],
  levelComplete: [20, 40, 20, 50, 30],
  warning: [18, 12, 18],
  error: [50, 20, 60],
};

export function getMenuHapticPattern(pattern: MenuHapticPattern): number[] {
  return [...MENU_PATTERNS[pattern]];
}
